/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementCreateSecondEventResponse } from './EventManagementCreateSecondEventResponse';

export type EventManagementCreateSecondEventResponseApiRespoonse = {
    data?: EventManagementCreateSecondEventResponse;
    status?: EventManagementCreateSecondEventResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementCreateSecondEventResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

